import inviewAnim from "./modules/inview";
import { setModal, globalNav } from "./modules/libs";
import { bindLiveFormMirrors, initFormValidation } from "./modules/form";
import { smoothScrollToTop, initSmoothScroll } from "./modules/scroll";
import { tab } from "./modules/tab";
import { kv } from "./modules/animation";

window.addEventListener("load", () => {
  tab();
  setModal();
  inviewAnim();
  bindLiveFormMirrors();
  initFormValidation();
  smoothScrollToTop();

  kv();

  const headerHeight =
    document.querySelector("#site-header")?.offsetHeight || 0;
  initSmoothScroll('a[href^="#"]', headerHeight);
  globalNav();
});
